import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { SelfServiceDetailsModel } from '../models/SelfServiceDetails';

@Injectable({
  providedIn: 'root'
})
export class SelfServiceService {
  private hostPath: string = JSON.parse(environment.IDENTITY);

  constructor(private http: HttpClient) { }

  public async GetDetailsByOrderNumberLastname(ordernumber: string, lastname: string): Promise<SelfServiceDetailsModel> {
    const model = { site: 'www.shuttlebuss.se', ordernumber, lastname };
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/GetDetailsByOrderNumberLastname`;

    const result = await this.http.post<SelfServiceDetailsModel>(URL, model, { 'headers': headers }).toPromise();
    return result;
  }

  public async GetDetailsByOrderNumberEmail(ordernumber: string, email: string): Promise<SelfServiceDetailsModel> {
    const model = { site: 'www.shuttlebuss.se', ordernumber, email };
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/GetDetailsByOrderNumberEmail`;

    const result = await this.http.post<SelfServiceDetailsModel>(URL, model, { 'headers': headers }).toPromise();
    return result;
  }

  public async SaveDetailsByOrderNumberLastname(orderNumber: string, lastname: string, carRegNumber: string, cellular: string, email: string, passengers: number, parkingFrom: string, contact: boolean, comment: string): Promise<SelfServiceDetailsModel> {
    parkingFrom = this.formatDate(new Date(parkingFrom));

    const model = {
      site: 'www.shuttlebuss.se',
      orderNumber,
      lastname,
      carRegNumber,
      cellular,
      email,
      passengers,
      parkingFrom,
      contact,
      comment
    };

    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/SaveDetailsByOrderNumberLastname`;

    const result = await this.http.post<SelfServiceDetailsModel>(URL, model, { 'headers': headers }).toPromise();
    return result;
  }

  public async SaveDetailsByOrderNumberEmail(orderNumber: string, carRegNumber: string, cellular: string, email: string, passengers: number, parkingFrom: string, contact: boolean, comment: string): Promise<SelfServiceDetailsModel> {
    parkingFrom = this.formatDate(new Date(parkingFrom));

    const model = {
      site: 'www.shuttlebuss.se',
      orderNumber,
      carRegNumber,
      cellular,
      email,
      passengers,
      parkingFrom,
      contact,
      comment
    };

    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/SaveDetailsByOrderNumberEmail`;

    const result = await this.http.post<SelfServiceDetailsModel>(URL, model, { 'headers': headers }).toPromise();
    return result;
  }

  public async CancelByOrderNumberEmail(orderNumber: string, email: string): Promise<SelfServiceDetailsModel> {

    const model = {
      site: 'www.shuttlebuss.se',
      orderNumber,
      email,
    };

    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/CancelByOrderNumberEmail`;
    const result = await this.http.post<SelfServiceDetailsModel>(URL, model, { 'headers': headers }).toPromise();
    return result;
  }

  ///Formats a local date with offset to a string witout the offset data
  formatDate(sourceDate: Date): string {
    var twoDigitMonth = ((sourceDate.getMonth() + 1) >= 10) ? (sourceDate.getMonth() + 1) : '0' + (sourceDate.getMonth() + 1);
    var twoDigitDate = ((sourceDate.getDate()) >= 10) ? (sourceDate.getDate()) : '0' + (sourceDate.getDate());
    var twoDigitHour = ((sourceDate.getHours()) >= 10) ? (sourceDate.getHours()) : '0' + (sourceDate.getHours());
    var twoDigitMinute = ((sourceDate.getMinutes()) >= 10) ? (sourceDate.getMinutes()) : '0' + (sourceDate.getMinutes());
    var returnDate = sourceDate.getFullYear() + "-" + twoDigitMonth + "-" + twoDigitDate + 'T' + twoDigitHour + ':' + twoDigitMinute + ':00';
    return returnDate;
  }

  public async getOrderListByAuthor() {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/GetOrderListByAuthor`;
    const result = await this.http.get<SelfServiceDetailsModel[]>(URL, { 'headers': headers }).toPromise();
    return result;
  }

  public async pickMeUp(data: any): Promise<SelfServiceDetailsModel> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/PickMeUp`;
    const result = await this.http.post<SelfServiceDetailsModel>(URL, data, { 'headers': headers }).toPromise();
    return result;
  }

  public async getParkingOperators(code: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/ParkingOperators?code=${code}`;
    const result = await this.http.get<any>(URL, { 'headers': headers }).toPromise();
    return result;
  }

  public async driveUpRegistration(gateId: string, licenseplate: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/DriveUpRegistration?gateId=${gateId}&licenseplate=${licenseplate}`;
    const result = await this.http.get<any>(URL, { 'headers': headers }).toPromise();
    return result;
  }

  public async completeDriveUpRegistration(model: any): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/DriveUpRegistration`;
    const result = await this.http.post<any>(URL, model, { 'headers': headers }).toPromise();
    return result;
  }

  public async driveUpAfterRegistration(licenseplate: any): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/DriveUpAfterRegistration?licenseplate=${licenseplate}`;
    const result = await this.http.get<any>(URL, { 'headers': headers }).toPromise();
    return result;
  }

  public async createDriveUpRegistration(model: any): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/CreateDriveUp`;
    const result = await this.http.post<any>(URL, model, { 'headers': headers }).toPromise();
    return result;
  }

  public async driveUpPaymentIsDone(gateId: string, orderId: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/DriveUpPaymentIsDone/${orderId}?gateId=${gateId}`;
    const result = await this.http.post<any>(URL, { 'headers': headers }).toPromise();
    return result;
  }

  public async cancelByOrderId(orderId: any): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/CancelByOrderId/${orderId}`;
    const result = await this.http.get<any>(URL, { 'headers': headers }).toPromise();
    return result;
  }

  public async checkExistingDriveUpOrder(gateId: string, licenseplate: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/CheckExistingOrderForDriveUp?gateId=${gateId}&licenseplate=${licenseplate}`;
    const result = await this.http.get<any>(URL, { 'headers': headers }).toPromise();
    return result;
  }

  public async checkExistingOrder(licenseplate: string, organizationId: string): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/CheckExistingOrder?licenseplate=${licenseplate}&organizationId=${organizationId}`;
    const result = await this.http.get<any>(URL, { 'headers': headers }).toPromise();
    return result;
  }

  public async calculateDriveUp(model: any): Promise<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/CalculateDriveUp`;
    const result = await this.http.post<any>(URL, model, { 'headers': headers }).toPromise();
    return result;
  }

}
